import { Text } from '#app/components/Primitives/Text.js';
import { css, styled } from 'styled-components';

export const Row = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    flex-flow: row nowrap;
    align-items: center;

    ${theme.mediaQueries.md} {
      align-items: center;
      margin-bottom: 32px;
    }
  `}
`;

export const Item = styled(Text)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const NameText = styled.h1`
  ${({ theme }) => css`
    display: flex;
    gap: 10px;
    align-items: center;
    text-shadow: 0px 0px 26px rgba(0, 0, 0, 0.06);
    color: ${theme.colorsV2.black};
    font-weight: 500;
    font-size: 23px;
    line-height: 32px;
    letter-spacing: -0.25px;
    margin-bottom: 4px;

    ${theme.mediaQueries.md} {
      margin-bottom: 2px;
      color: ${theme.colorsV2.white};
      line-height: 44px;
      letter-spacing: -0.5px;
      font-size: 34px;
    }
  `}
`;

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    color: ${theme.colorsV2.gray70};
    margin-bottom: 4px;

    ${theme.mediaQueries.md} {
      margin: 32px 0;
      color: ${theme.colorsV2.white};
    }
  `}
`;
